module.exports = __webpack_public_path__ + "media/images/flags/32/Dominica-3d89e9d55f4a409e1e27a3e5919f4476.png";